"use client";

import { c as _c } from "react/compiler-runtime";
import { Toaster } from "@chatapp/ui/components/sonner";
import { ThemeProvider } from "./theme-provider";
export default function Providers(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Toaster richColors={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} disableTransitionOnChange={true}>{children}{t1}</ThemeProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}